// DON't CHANGE!
// automated by SVGR script
import * as React from "react";
const Ticket2Icon = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20",
  "aria-hidden": "true",
  "data-icon": "Ticket2/solid"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M14.325 4.133v.017c-.208-.008-.417-.017-.642-.017H7.267l.891-.883c.817-.825 1.717-1.583 2.759-1.583 1.05 0 1.95.758 2.766 1.583l.467.467a.56.56 0 0 1 .175.416ZM17.367 10.975a.589.589 0 0 0 .583-.6v-.733c0-3.275-1-4.267-4.267-4.267H6.317c-3.267 0-4.267 1-4.267 4.267V10c0 .333.258.592.583.592.7 0 1.259.566 1.259 1.258 0 .692-.559 1.267-1.259 1.267a.582.582 0 0 0-.583.591v.359c0 3.275 1 4.266 4.267 4.266H13.675c3.267 0 4.267-1 4.267-4.266a.587.587 0 0 0-.584-.592 1.25 1.25 0 0 1-1.258-1.25 1.263 1.263 0 0 1 1.267-1.25Zm-8.35 4.742a.594.594 0 0 1-.592.591.594.594 0 0 1-.592-.591v-2.234c0-.325.267-.591.592-.591.325 0 .592.266.592.591v2.234Zm0-5.492a.594.594 0 0 1-.592.592.594.594 0 0 1-.592-.592V7.992c0-.325.267-.592.592-.592.325 0 .592.267.592.592v2.233Z"
}));
export default Ticket2Icon;